
import Typography from '@/ui-kit/components/typography';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import IconButton from '@/ui-kit/components/icon-button';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import { IconType } from '@/ui-kit/components/icon/enums';
import { KeyboardKeyCode } from '@/ui-kit/enums';
import { ModalSlotName, ModalViewType } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import WindowSize from '@/ui-kit/mixins/windowSize';
import {
  ImageGalleryPaginationType,
  ImageGalleryRef,
  ImageGallerySlotName,
  ImageGalleryPropsEventType,
} from './enums';
import ImageGallery from './index';

export default {
  name: 'ImageGalleryModal',
  components: {
    Typography,
    ImageGallery,
    ModalWindow,
    IconButton,
  },
  mixins: [
    ModalCommonProps,
    WindowSize,
    ImageGalleryRef,
  ],
  data() {
    return {
      ModalSlotName,
      StyleColorSchemeType,
      IconType,
      ImageGalleryRef,
      ImageGallerySlotName,
      ImageGalleryPaginationType,
      ImageGalleryPropsEventType,
      TypographyProperty,
      TypographyType,
      activeIndex: null,
    };
  },
  computed: {
    resultModalOptions() {
      return {
        ...this.modalOptions,
        viewType: ModalViewType.FullWidth,
      };
    },
    description() {
      return this.modalData?.images[this.activeIndex]?.description;
    },
  },
  mounted() {
    this.activeIndex = this.modalData.activeIndex;
  },
  methods: {
    handleKeypress({ code }) {
      // eslint-disable-next-line default-case
      switch (code) {
        case KeyboardKeyCode.ArrowLeft:
        case KeyboardKeyCode.ArrowDown:
          this.clickRefElement(ImageGalleryRef.PreviousButton);
          break;
        case KeyboardKeyCode.ArrowRight:
        case KeyboardKeyCode.ArrowUp:
          this.clickRefElement(ImageGalleryRef.NextButton);
          break;
        case KeyboardKeyCode.Escape:
          this.closeHandler();
          break;
      }
    },
    clickRefElement(name) {
      this.getRef(name).$el.click();
    },
    getRef(name) {
      return this.$refs[name];
    },
    handleImageIndexChange(index) {
      this.activeIndex = index;
    },
  },
};
